import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";

import App from "./App.vue";
import router from "./router";
import store from "./store/";
import i18n from "./locales";
import LoginAndRegistrationLayout from "./layouts/LoginAndRegistrationLayout";
import MainLayout from "./layouts/MainLayout";
import PageNotFoundLayout from "./layouts/PageNotFoundLayout";
import MtgIcon from "./components/icons/MtgIcon";

import VueClipboard from "vue-clipboard2";
import VCalendar from "v-calendar";
import vClickOutside from "v-click-outside";
import VueMobileDetection from "vue-mobile-detection";
import tooltip from "bootstrap-vue/src/directives/tooltip/tooltip";

Vue.use(BootstrapVue);
Vue.use(VueClipboard);
Vue.use(VCalendar);
Vue.use(vClickOutside);
Vue.use(VueMobileDetection);

Vue.component("LoginAndRegistrationLayout", LoginAndRegistrationLayout);
Vue.component("MainLayout", MainLayout);
Vue.component("PageNotFoundLayout", PageNotFoundLayout);
Vue.component("MtgIcon", MtgIcon);

Vue.directive('click-outside', vClickOutside);
Vue.directive('b-tooltip', tooltip);

//  let lang = store.state.locale;
//  if (lang) {
// //   // Set the locale in $i18n
//    i18n.locale = lang;
//  }
i18n.locale = "en";

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

window["vue"] = app;
window.store = store;
